export default __webpack_public_path__ + "static/media/tender.8f7c0670.svg";